module.exports = __webpack_public_path__ + "assets/img/ambition-2.8d9d20a3.svg";